/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetProResultExportDataParams,
  GetProfessionalUsersParams,
  GetRepResultExportDataParams,
  GetRepUsersParams,
  HTTPValidationError,
  NameSearchResponse,
  SearchExportResponse,
  SearchOrganizationsByNameParams,
  SearchUsersByNameParams,
  UserListResponse,
} from './platformapi.schemas';

import searchOrganizationsByNameMutator from '../custom-axios-instance';
import getProResultExportDataMutator from '../custom-axios-instance';
import getProfessionalUsersMutator from '../custom-axios-instance';
import getRepResultExportDataMutator from '../custom-axios-instance';
import getRepUsersMutator from '../custom-axios-instance';
import searchUsersByNameMutator from '../custom-axios-instance';

/**
 * Lightweight name search across all organizations, for autocomplete-style lookups.
 * @summary Search Organizations By Name
 */
export const searchOrganizationsByName = (
  params?: SearchOrganizationsByNameParams,
  signal?: AbortSignal,
) => {
  return searchOrganizationsByNameMutator<NameSearchResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/search/organizations`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSearchOrganizationsByNameQueryKey = (params?: SearchOrganizationsByNameParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/search/organizations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchOrganizationsByNameQueryOptions = <
  TData = Awaited<ReturnType<typeof searchOrganizationsByName>>,
  TError = HTTPValidationError,
>(
  params?: SearchOrganizationsByNameParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrganizationsByName>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchOrganizationsByNameQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchOrganizationsByName>>> = ({
    signal,
  }) => searchOrganizationsByName(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchOrganizationsByName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchOrganizationsByNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchOrganizationsByName>>
>;
export type SearchOrganizationsByNameQueryError = HTTPValidationError;

export function useSearchOrganizationsByName<
  TData = Awaited<ReturnType<typeof searchOrganizationsByName>>,
  TError = HTTPValidationError,
>(
  params: undefined | SearchOrganizationsByNameParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrganizationsByName>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOrganizationsByName>>,
          TError,
          Awaited<ReturnType<typeof searchOrganizationsByName>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchOrganizationsByName<
  TData = Awaited<ReturnType<typeof searchOrganizationsByName>>,
  TError = HTTPValidationError,
>(
  params?: SearchOrganizationsByNameParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrganizationsByName>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchOrganizationsByName>>,
          TError,
          Awaited<ReturnType<typeof searchOrganizationsByName>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchOrganizationsByName<
  TData = Awaited<ReturnType<typeof searchOrganizationsByName>>,
  TError = HTTPValidationError,
>(
  params?: SearchOrganizationsByNameParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrganizationsByName>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search Organizations By Name
 */

export function useSearchOrganizationsByName<
  TData = Awaited<ReturnType<typeof searchOrganizationsByName>>,
  TError = HTTPValidationError,
>(
  params?: SearchOrganizationsByNameParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchOrganizationsByName>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchOrganizationsByNameQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a list of professional users based on filter criteria for export.
 * @summary Get Pro Result Export Data
 */
export const getProResultExportData = (
  params?: GetProResultExportDataParams,
  signal?: AbortSignal,
) => {
  return getProResultExportDataMutator<SearchExportResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/search/pro-export-results`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProResultExportDataQueryKey = (params?: GetProResultExportDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/search/pro-export-results`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProResultExportDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getProResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetProResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProResultExportData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProResultExportDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProResultExportData>>> = ({ signal }) =>
    getProResultExportData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProResultExportData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProResultExportDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProResultExportData>>
>;
export type GetProResultExportDataQueryError = HTTPValidationError;

export function useGetProResultExportData<
  TData = Awaited<ReturnType<typeof getProResultExportData>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetProResultExportDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProResultExportData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProResultExportData>>,
          TError,
          Awaited<ReturnType<typeof getProResultExportData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProResultExportData<
  TData = Awaited<ReturnType<typeof getProResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetProResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProResultExportData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProResultExportData>>,
          TError,
          Awaited<ReturnType<typeof getProResultExportData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProResultExportData<
  TData = Awaited<ReturnType<typeof getProResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetProResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProResultExportData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Pro Result Export Data
 */

export function useGetProResultExportData<
  TData = Awaited<ReturnType<typeof getProResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetProResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProResultExportData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProResultExportDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a paginated list of professional users based on filter criteria.
 * @summary Get Professional Users
 */
export const getProfessionalUsers = (params?: GetProfessionalUsersParams, signal?: AbortSignal) => {
  return getProfessionalUsersMutator<UserListResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/search/professional-users`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetProfessionalUsersQueryKey = (params?: GetProfessionalUsersParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/search/professional-users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetProfessionalUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getProfessionalUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetProfessionalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalUsers>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProfessionalUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfessionalUsers>>> = ({ signal }) =>
    getProfessionalUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProfessionalUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProfessionalUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProfessionalUsers>>
>;
export type GetProfessionalUsersQueryError = HTTPValidationError;

export function useGetProfessionalUsers<
  TData = Awaited<ReturnType<typeof getProfessionalUsers>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetProfessionalUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalUsers>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfessionalUsers<
  TData = Awaited<ReturnType<typeof getProfessionalUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetProfessionalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProfessionalUsers>>,
          TError,
          Awaited<ReturnType<typeof getProfessionalUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProfessionalUsers<
  TData = Awaited<ReturnType<typeof getProfessionalUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetProfessionalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Professional Users
 */

export function useGetProfessionalUsers<
  TData = Awaited<ReturnType<typeof getProfessionalUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetProfessionalUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProfessionalUsers>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProfessionalUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a list of representative users based on filter criteria for export.
 * @summary Get Rep Result Export Data
 */
export const getRepResultExportData = (
  params?: GetRepResultExportDataParams,
  signal?: AbortSignal,
) => {
  return getRepResultExportDataMutator<SearchExportResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/search/rep-export-results`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetRepResultExportDataQueryKey = (params?: GetRepResultExportDataParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/search/rep-export-results`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRepResultExportDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getRepResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetRepResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRepResultExportData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRepResultExportDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepResultExportData>>> = ({ signal }) =>
    getRepResultExportData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRepResultExportData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRepResultExportDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRepResultExportData>>
>;
export type GetRepResultExportDataQueryError = HTTPValidationError;

export function useGetRepResultExportData<
  TData = Awaited<ReturnType<typeof getRepResultExportData>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetRepResultExportDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRepResultExportData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepResultExportData>>,
          TError,
          Awaited<ReturnType<typeof getRepResultExportData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRepResultExportData<
  TData = Awaited<ReturnType<typeof getRepResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetRepResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRepResultExportData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepResultExportData>>,
          TError,
          Awaited<ReturnType<typeof getRepResultExportData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRepResultExportData<
  TData = Awaited<ReturnType<typeof getRepResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetRepResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRepResultExportData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Rep Result Export Data
 */

export function useGetRepResultExportData<
  TData = Awaited<ReturnType<typeof getRepResultExportData>>,
  TError = HTTPValidationError,
>(
  params?: GetRepResultExportDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRepResultExportData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRepResultExportDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a paginated list of representative users based on filter criteria.
 * @summary Get Rep Users
 */
export const getRepUsers = (params?: GetRepUsersParams, signal?: AbortSignal) => {
  return getRepUsersMutator<UserListResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/search/rep-users`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetRepUsersQueryKey = (params?: GetRepUsersParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/search/rep-users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRepUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getRepUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetRepUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepUsers>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRepUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepUsers>>> = ({ signal }) =>
    getRepUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRepUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRepUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getRepUsers>>>;
export type GetRepUsersQueryError = HTTPValidationError;

export function useGetRepUsers<
  TData = Awaited<ReturnType<typeof getRepUsers>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetRepUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepUsers>>,
          TError,
          Awaited<ReturnType<typeof getRepUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRepUsers<
  TData = Awaited<ReturnType<typeof getRepUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetRepUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepUsers>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepUsers>>,
          TError,
          Awaited<ReturnType<typeof getRepUsers>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetRepUsers<
  TData = Awaited<ReturnType<typeof getRepUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetRepUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepUsers>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Rep Users
 */

export function useGetRepUsers<
  TData = Awaited<ReturnType<typeof getRepUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetRepUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepUsers>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRepUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Lightweight name search across all users, for autocomplete-style lookups.
 * @summary Search Users By Name
 */
export const searchUsersByName = (params?: SearchUsersByNameParams, signal?: AbortSignal) => {
  return searchUsersByNameMutator<NameSearchResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/search/users`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSearchUsersByNameQueryKey = (params?: SearchUsersByNameParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/search/users`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchUsersByNameQueryOptions = <
  TData = Awaited<ReturnType<typeof searchUsersByName>>,
  TError = HTTPValidationError,
>(
  params?: SearchUsersByNameParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsersByName>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchUsersByNameQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchUsersByName>>> = ({ signal }) =>
    searchUsersByName(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchUsersByName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchUsersByNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchUsersByName>>
>;
export type SearchUsersByNameQueryError = HTTPValidationError;

export function useSearchUsersByName<
  TData = Awaited<ReturnType<typeof searchUsersByName>>,
  TError = HTTPValidationError,
>(
  params: undefined | SearchUsersByNameParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsersByName>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsersByName>>,
          TError,
          Awaited<ReturnType<typeof searchUsersByName>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchUsersByName<
  TData = Awaited<ReturnType<typeof searchUsersByName>>,
  TError = HTTPValidationError,
>(
  params?: SearchUsersByNameParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsersByName>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchUsersByName>>,
          TError,
          Awaited<ReturnType<typeof searchUsersByName>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchUsersByName<
  TData = Awaited<ReturnType<typeof searchUsersByName>>,
  TError = HTTPValidationError,
>(
  params?: SearchUsersByNameParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsersByName>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search Users By Name
 */

export function useSearchUsersByName<
  TData = Awaited<ReturnType<typeof searchUsersByName>>,
  TError = HTTPValidationError,
>(
  params?: SearchUsersByNameParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchUsersByName>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchUsersByNameQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
